<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { getTranslate } from '@tolgee/svelte';
	import Button from '../Button/Button.svelte';
	import { logInWithSocial } from '$lib/service/supabase/user.service';
	import { classes } from '$lib/utils';
	import LinkedInSignInIcon from '../Icon/LinkedInSignInIcon.svelte';
	import GoogleSignInIcon from '../Icon/GoogleSignInIcon.svelte';
	import type { Provider } from '@supabase/supabase-js';

	const { t } = getTranslate();
	const dispatch = createEventDispatcher();

	export let additionalClass = '';

	let loading = false;
	let serverError: string = '';

	const handleSignIn = async (provider: Provider) => {
		loading = true;

		try {
			// Socials don't return the user data
			await logInWithSocial(provider, {
				redirectTo: `${window.location.origin}/auth/callback`
			});
		} catch (error: any) {
			console.error('ERROR while logging in', error);
			const { message } = error;
			serverError = message;
			dispatch('error', error);
		} finally {
			loading = false;
		}
	};
</script>

<div class={classes(additionalClass, 'flex flex-col items-center justify-center')}>
	<div class="space-y-4 lg:space-y-6 w-full flex flex-col justify-center">
		<div class="text-center">
			<Button
				on:click={() => handleSignIn('google')}
				additionalClass="mt-4 w-full !text-purple bg-white !border-purple hover:bg-purple hover:!text-white"
				><div class="flex flex-row items-center stroke-2 gap-2">
					<GoogleSignInIcon additionalClass="text-white" />{$t('login.with_google.button')}
				</div></Button
			>
			<Button
				on:click={() => handleSignIn('linkedin_oidc')}
				additionalClass="mt-4 w-full !text-purple bg-white !border-purple hover:bg-purple hover:!text-white"
				><div class="flex flex-row items-center stroke-2 gap-2">
					<LinkedInSignInIcon additionalClass="text-white -mt-1" />{$t(
						'login.with_linkedin.button'
					)}
				</div></Button
			>
		</div>
		{#if serverError}
			<div class="text-error">{serverError}</div>
		{/if}
	</div>
</div>
